import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';

import { AuthProvider } from './context/AuthContext';
import { SettingsProvider } from './context/SettingsContext';
import { Toaster } from './components/ui/toaster';

import PublicLayout from './layouts/PublicLayout';
import AdminLayout from './layouts/AdminLayout';

import Home from './pages/Home';
import CruisesList from './pages/CruisesList';
import CruiseDetail from './pages/CruiseDetail';
import PackagesList from './pages/PackagesList';
import PackageDetail from './pages/PackageDetail';
import ToursPage from './pages/ToursPage';
import BlogList from './pages/BlogList';
import BlogDetail from './pages/BlogDetail';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import RequestQuotePage from './pages/RequestQuotePage';

import AdminLogin from './pages/AdminLogin';
import AdminHome from './pages/admin/AdminHome';
import AdminCruises from './pages/admin/AdminCruises';
import AdminPackages from './pages/admin/AdminPackages';
import AdminTours from './pages/admin/AdminTours';
import AdminBlog from './pages/admin/AdminBlog';
import AdminFAQ from './pages/admin/AdminFAQ';
import AdminLeads from './pages/admin/AdminLeads';
import AdminSettings from './pages/admin/AdminSettings';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SettingsProvider>
          <AuthProvider>
            <ScrollToTop />
            <Routes>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminHome />} />
                <Route path="cruises" element={<AdminCruises />} />
                <Route path="packages" element={<AdminPackages />} />
                <Route path="tours" element={<AdminTours />} />
                <Route path="blog" element={<AdminBlog />} />
                <Route path="faqs" element={<AdminFAQ />} />
                <Route path="leads" element={<AdminLeads />} />
                <Route path="settings" element={<AdminSettings />} />
              </Route>

              <Route path="/" element={<PublicLayout />}>
                <Route index element={<Home />} />
                <Route path="cruises" element={<CruisesList />} />
                <Route path="cruises/:slug" element={<CruiseDetail />} />
                <Route path="packages" element={<PackagesList />} />
                <Route path="packages/:slug" element={<PackageDetail />} />
                <Route path="tours" element={<ToursPage />} />
                <Route path="blog" element={<BlogList />} />
                <Route path="blog/:slug" element={<BlogDetail />} />
                <Route path="about" element={<AboutPage />} />
                <Route path="contact" element={<ContactPage />} />
                <Route path="request-quote" element={<RequestQuotePage />} />
              </Route>
            </Routes>
            <Toaster />
          </AuthProvider>
        </SettingsProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
